export default __webpack_public_path__ + "static/media/420.17f08c8e.png";